import React from 'react';

import Loading from '../../Loading';
import useSankeyData from './useSankeyData';
import SankeyView from './SankeyView';

const SankeyContent = ({
  chartDefinition,
  chartRef,
  useSmallNoDataMessage,
}: {
  chartDefinition: V5ChartDefinition;
  chartRef: React.MutableRefObject<any>;
  useSmallNoDataMessage: boolean;
}) => {
  const { options, isNoData, isReady } = useSankeyData({
    chartDefinition,
    chartRef,
  });

  if (!isReady) {
    return <Loading />;
  }

  return (
    <SankeyView
      chartRef={chartRef}
      options={options ?? {}}
      // Treat "no options yet" as no-data so Highcharts is never handed an
      // empty chart (which warns #12) during config before dimensions are set.
      isNoData={isNoData || !options}
      useSmallNoDataMessage={useSmallNoDataMessage}
    />
  );
};

export default SankeyContent;
